<template>
  <v-theme-provider :dark="dark">
    <div>
      <base-info-card :title="title" color="primary">
        <slot />
      </base-info-card>

      <template v-for="({ icon, text, title: t }, i) in business">
        <base-avatar-card
          :key="i"
          :icon="icon"
          :outlined="false"
          :title="!dense ? t : undefined"
          color="transparent"
          horizontal
          space="0"
        >
          <!-- Do not use v-html for user -->
          <!-- provided values -->
          <div v-html="text" />
        </base-avatar-card>

        <v-divider
          v-if="i + 1 !== business.length"
          :key="`divider-${i}`"
          class="my-2"
        />
      </template>
    </div>
  </v-theme-provider>
</template>

<script>
export default {
  name: "BaseBusinessContact",

  props: {
    dark: Boolean,
    dense: Boolean,
    title: String,
  },

  data: () => ({
    business: [
      {
        color: "#000000",
        icon: "mdi-map-marker-outline",
        title: "Address",
        text: "810 Geylang Rd, #03-145D City Plaza, Singapore 409286",
      },
      {
        color: "#000000",
        icon: "mdi-cellphone",
        title: "Phone",
        text: " +65 8068 8811 / +65 8812 0772",
      },
      {
        color: "#000000",
        icon: "mdi-email",
        title: "Email",
        text: "contact@JoanRecruit.com <br> www.JoanRecruit.com",
      },
      {
        color: "#000000",
        icon: "mdi-clock",
        title: "Time",
        text: "Monday - Sunday 11am to 8pm (please make an appointment)",
      },
    ],
  }),
};
</script>
<style scoped>
.icon {
  color: red;
}
</style>
